/*
 * Copyright (c) 2020 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps} from '../types/types';
import ThemeIconProvider from './ThemeIconProvider';
import useIconDLS from './useIconDLS';

/*
 * Defines the Design Language System (DLS) Map Edit Icon component.
 */
export const MapEditIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <ThemeIconProvider name='MapEditIcon' {...props} legacyIcon={(
      <svg width={iconSize} height={iconSize} viewBox='0 0 25 25' fill='none'>
        <path d='M5.618 23.072l-.012.02.012-.02a.068.068 0 01-.02-.017l-.733-3.428 10.05-17.454 4.132 2.381L8.994 21.997l-3.351 1.084a.067.067 0 01-.025-.009zm-.8-3.362h0s0 0 0 0l-.217-.125.216.125z'
          stroke={iconColor}
          strokeWidth={1.5}
          strokeMiterlimit={10} />
        <path d='M17.735 12.058a.75.75 0 101.299.75l-1.3-.75zm3.863-6.691l-3.863 6.69 1.299.75 3.863-6.69-1.3-.75z'
          fill={iconColor} />
        <path d='M12.346 5.76l4.78 2.76'
          stroke={iconColor}
          strokeWidth={1.5}
          strokeMiterlimit={10} />
      </svg>
    )} />
  );
};
